import { Box } from "@mui/material";
import {
    DatepickerInput,
    TextInput,
} from "@nn-design-system/react-component-library";
import React from "react";
import { colourTextDefault } from "../../Config/colors";

type CustomDateInputProps = {
    labelText: string;
    value: Date | undefined;
    subtext?: string;
    onChange: (value: string | null) => void;
    validationText: string;
    name?: string;
    placeholderText?: string;
    dependencyValue?: boolean | null;
    onBlur?: any;
    inputRef?: React.RefObject<HTMLDivElement>;
};

const CustomDateInput: React.FC<CustomDateInputProps> = ({
    labelText,
    value,
    onChange,
    validationText,
    name,
    subtext,
    placeholderText = "DD.MM.RRRR",
    dependencyValue = true,
    onBlur,
    inputRef,
}) => {

    const onChangeHandler = (value: Date | null) => {
        if (!value || isNaN(value.getTime())) {
            onChange(null);
            return;
        }

        const yyyy = value.getFullYear();
        const mm = String(value.getMonth() + 1).padStart(2, '0');
        const dd = String(value.getDate()).padStart(2, '0');
        const dateString = `${yyyy}-${mm}-${dd}`;

        const regex = /^\d{4}-\d{2}-\d{2}$/;
        if (!regex.test(dateString)) {
            onChange(null);
            return;
        }

        const dateTimeString = `${dateString}T00:00:00Z`;
        onChange(dateTimeString);
    }

    return dependencyValue ? (
        <Box
            sx={{
                "& > div > div > div > div > div": {
                    outlineColor: `${colourTextDefault} !important`,
                    "&:focus": {},
                },
            }}
        >
            <div ref={inputRef}>
                <DatepickerInput
                    subtext={subtext}
                    name={name}
                    labelText={labelText}
                    value={value}
                    onChange={onChangeHandler}
                    validationText={validationText}
                    placeholderText={placeholderText}
                    onBlur={onBlur}
                />
            </div>
        </Box>
    ) : null;
};

export default CustomDateInput;
